// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__8wq+M","cover_caption":"Carousel_cover_caption__PSLOF","cover_thumb":"Carousel_cover_thumb__MiHmp","mobile_drag":"Carousel_mobile_drag__B8JxR"};